














































import Vue from 'vue';
import axios from 'axios';

export default Vue.extend(
    {
        data() {
            return {
                records: {} as any
            }
        },
        methods: {
            fetchEPIC: function () {
                //let apiKey = 'DEMO_KEY'; //replace with real apikey. demo key is for limited use only
                let apiKey = '7mUh8iioKZFlbIvludFrzdeUauQeReg35rNZUqyE' //nasa.gov api key for dutch@adachis.info
                let url = 'https://api.nasa.gov/EPIC/api/natural/images?api_key=' + apiKey;
                axios.get(url)
                    .then((res) => {
                        this.records = res.data;
                    })
            },
            getImageThumbs: function (a: any) {
                let url = `https://epic.gsfc.nasa.gov/archive/natural/`
                    + a.identifier.substr(0, 4) + '/' //year
                    + a.identifier.substr(4, 2) + '/'  // month
                    + a.identifier.substr(6, 2)   //day
                ;
                return `<a href="${url}/jpg/${a.image}.jpg"><img src="${url}/thumbs/${a.image}.jpg"></a>`
            },
            getImageSrc: function (a: any) {
                let url = `https://epic.gsfc.nasa.gov/archive/natural/`
                    + a.identifier.substr(0, 4) + '/' //year
                    + a.identifier.substr(4, 2) + '/'  // month
                    + a.identifier.substr(6, 2)   //day
                ;
                return `${url}/jpg/${a.image}.jpg`
            }


        },
        created: function () {
            this.fetchEPIC();
        }


    }
)
